<!--Header-->
<app-navbar xmlns="http://www.w3.org/1999/html">
    <h2>{{'REFERAL.TITLE' | translate}}</h2>
</app-navbar>

<!--Empty row 30-->
<div class="empty-row-30"></div>
<!--Contul tau-->
<div class="container">
    <app-check-current-user></app-check-current-user>
</div>

<div class="container info-recom">
    <h4 class="custom-section-title">{{'REFERAL.SUBTITLE' | translate}}</h4>
    <p [innerHTML]="'REFERAL.INTRO_HTML' | translate"></p>
</div>


<!--Recomanda Candidat/Companie buttons-->
<div class="recommendBtn">
    <div class="container">
        <div class="row">
            <!--Recomanda un candidat button-->
            <div class="col-12 col-md-6">
                <a (click)="displayFormCandidate()"
                   [ngClass]="isDisplayedCompany? 'green-btn w-100 text-center' : 'grey-button w-100 text-center'">{{'REFERAL.CANDIDATE' | translate}}</a>
            </div>
            <!--Recomanda o companie button-->
            <div class="col-12 col-md-6">
                <a (click)="displayFormCompany()"
                   [ngClass]="isDisplayedCandidate? 'green-btn w-100 text-center' : 'grey-button w-100 text-center'">{{'REFERAL.COMPANY' | translate}}</a>
            </div>

        </div>
    </div>
</div>
<!--Empty row 30-->
<div class="empty-row-30"></div>
<!--Detalii Recomandare section-->
<div class="recommend-details">
    <div class="container">
        <!--Form title -->
        <div class="details-title-area">
            <h4>{{'REFERAL.DETAILS' | translate}}</h4>
        </div>

        <!-- Form-->
        <form (ngSubmit)="onSubmitCompany(recommendFormCompany)" *ngIf="isDisplayedCandidate"
              #recommendFormCompany='ngForm'>

            <!--                [useLoader]="isLoading"-->
            <div *ngIf="formHasBeenSend">
                <p class="">{{succesMessage}}</p>

            </div>
            <div class="details-area bg-white">
                <div class="row d-flex align-content-center">
                    <!--Numele -->

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="name">{{'REFERAL.C_NAME_LABEL' | translate}}</label>

                            <input type="text"
                                   id="nameComp"
                                   class="form-control"
                                   ngModel
                                   name="name"
                                   placeholder="{{'REFERAL.C_NAME_PLACEHOLDER' | translate}}"
                                   #nameComp="ngModel"
                                   required>
                            <div class="error-msg"
                                 *ngIf="!nameComp.valid && (nameComp.touched || recommendFormCompany.submitted)">{{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>
                    <!-- Prenumele-->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="recommendedBy">{{'REFERAL.MY_NAME_LABEL' | translate}}</label>
                            <!--daca user-ul este logat se auto completeaza numele si prenumele -->
                            <div *ngIf="this.userDataService.isLoggedIn==true">
                                <input name="recommendedBy"
                                       class="form-control"
                                       [ngModel]='fullName'
                                       required
                                       #userFullName="ngModel"

                                >
                                <div class="error-msg"
                                     *ngIf="!userFullName.valid && (userFullName.touched || recommendFormCompany.submitted)">
                                    {{'VALIDATION.REQUIRED' | translate}}
                                </div>
                            </div>
                            <!--daca user-ul nu este logat campul ramane necompletat -->
                            <div *ngIf="this.userDataService.isLoggedIn==false">
                                <input type="text"
                                       id="recommendedByCand"
                                       name="recommendedBy"
                                       class="form-control"
                                       ngModel
                                       placeholder="{{'REFERAL.MY_NAME_PLACEHOLDER' | translate}}"
                                       #recommendedByComp="ngModel"
                                       required>
                                <div class="error-msg"
                                     *ngIf="!recommendedByComp.valid && (recommendedByComp.touched || recommendFormCompany.submitted)">
                                     {{'VALIDATION.REQUIRED' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Email -->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="email">{{'REFERAL.C_EMAIL' | translate}}</label>
                            <input type="text"
                                   id="emailComp"
                                   class="form-control"
                                   ngModel
                                   name="email"
                                   placeholder="Email"
                                   #emailComp="ngModel"
                                   required
                            >
                            <div class="error-msg"
                                 *ngIf="!emailComp.valid && (emailComp.touched || recommendFormCompany.submitted)">{{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                    </div>
                    <!-- Telefon-->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="telephone">{{'REFERAL.C_PHONE' | translate}}</label>
                            <input type="text"
                                   id="telephoneComp"
                                   class="form-control"
                                   ngModel
                                   name="telephone"
                                   placeholder="{{'REFERAL.C_PHONE_PLACEHODER' | translate}}"
                                   #telephoneComp="ngModel"
                                   required>
                            <div class="error-msg"
                                 *ngIf="!telephoneComp.valid && (telephoneComp.touched || recommendFormCompany.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                    </div>
                    <!-- Link Facebook-->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="facebookLink">{{'REFERAL.C_FACEBOOK' | translate}}</label>
                            <input type="text"
                                   id="facebookLinkComp"
                                   class="form-control"
                                   ngModel
                                   name="facebookLink"
                                   placeholder="{{'REFERAL.C_FB_PLACEHOLDER' | translate}}"
                                   #facebookLink="ngModel"
                            >

                        </div>
                    </div>
                    <!--Link LinkedIn -->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="linkedinLink">{{'REFERAL.C_LINKEDIN' | translate}}</label>
                            <input type="text"
                                   id="linkedinLink"
                                   class="form-control"
                                   ngModel
                                   name="linkedinLink"
                                   placeholder="{{'REFERAL.C_LK_PLACEHOLDER' | translate}}"
                                   #linkedinLink="ngModel"
                            >
                        </div>
                    </div>
                    <!-- Textarea-->
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label for="message">{{'REFERAL.C_DESCRIPTION' | translate}}</label>
                            <textarea class="form-control"
                                      id="messageComp"
                                      type="text"
                                      rows="6"
                                      ngModel
                                      name="message"
                                      placeholder="{{'REFERAL.C_DESCRIPTION_PLACEHOLDER' | translate}}"
                                      #messageComp="ngModel"
                                      required
                            ></textarea>
                            <div class="error-msg"
                                 *ngIf="!messageComp.valid && (messageComp.touched || recommendFormCompany.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 gdpr-fields">
                        <div class="form-group">
                            <input type="checkbox" id="personalGdpr" name="personalGdpr" #personalGdprControl="ngModel" [(ngModel)]="personalGdprChecked">
                            <label for="personalGdpr">{{'REFERAL.TERMS_READ' | translate}}<a routerLink="/politica-confidentialitate">{{'REFERAL.POLICY' | translate}}</a> {{'REFERAL.AND' | translate}} <a routerLink="/termeni-si-conditii">{{'REFERAL.TERMS' | translate}}</a>.</label>
                            <div class="error-msg"
                                 *ngIf="!personalGdprChecked && recommendFormCompany.submitted">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="checkbox" id="recomGdpr" name="recomGdpr" #recomGdprControl="ngModel" [(ngModel)]="recomGdprChecked">
                            <label for="recomGdpr">{{'REFERAL.PERMISSION' | translate}}</label>
                            <div class="error-msg"
                                 *ngIf="!recomGdprChecked && recommendFormCompany.submitted">
                                {{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>
                    </div>

                    <!--Trimite button-->
                    <div class="col-12">
                        <button type="submit"
                                class="green-button float-right">{{'BUTTONS.SEND' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </form>


        <form (ngSubmit)="onSubmitCandidate(recommendFormCandidate)" *ngIf="isDisplayedCompany"
              #recommendFormCandidate='ngForm'>

            <!--                [useLoader]="isLoading"-->
            <div *ngIf="formHasBeenSend">
                <p class="">{{succesMessage}}</p>

            </div>
            <div class="details-area bg-white">
                <div class="row d-flex align-content-center">
                    <!--Numele -->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="name">{{'REFERAL.E_NAME_LABEL' | translate}}</label>
                            <!--daca user-ul este logat se auto completeaza numele si prenumele -->

                            <input type="text"
                                   id="name"
                                   class="form-control"
                                   ngModel
                                   name="name"
                                   placeholder="{{'REFERAL.E_NAME_PLACEHOLDER' | translate}}"
                                   #name="ngModel"
                                   required>
                            <div class="error-msg"
                                 *ngIf="!name.valid && (name.touched || recommendFormCandidate.submitted)">{{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                    </div>
                    <!-- Prenumele-->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="recommendedBy">{{'REFERAL.MY_NAME_LABEL' | translate}}</label>
                            <!--daca user-ul este logat se auto completeaza numele si prenumele -->
                            <div *ngIf="this.userDataService.isLoggedIn==true">
                                <input name="recommendedBy"
                                       class="form-control"
                                       [ngModel]='fullName'
                                >
                            </div>
                            <!--daca user-ul nu este logat campul ramane necompletat -->
                            <div *ngIf="this.userDataService.isLoggedIn==false">
                                <input type="text"
                                       id="recommendedBy"
                                       name="recommendedBy"
                                       class="form-control"
                                       ngModel
                                       placeholder="{{'REFERAL.MY_NAME_PLACEHOLDER' | translate}}"
                                       #recommendedBy="ngModel"
                                       required>
                                <div class="error-msg"
                                     *ngIf="!recommendedBy.valid && (recommendedBy.touched || recommendFormCandidate.submitted)">
                                    {{'VALIDATION.REQUIRED' | translate}}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Email -->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="email">{{'REFERAL.E_EMAIL' | translate}}</label>
                            <input type="text"
                                   id="email"
                                   class="form-control"
                                   ngModel
                                   name="email"
                                   placeholder="Email"
                                   #email="ngModel"
                                   required>
                            <div class="error-msg"
                                 *ngIf="!email.valid && (email.touched || recommendFormCandidate.submitted)">{{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                    </div>
                    <!-- Telefon-->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="telephone">{{'REFERAL.E_PHONE' | translate}}</label>
                            <input type="text"
                                   id="telephone"
                                   class="form-control"
                                   ngModel
                                   name="telephone"
                                   placeholder="{{'REFERAL.C_PHONE_PLACEHODER' | translate}}"
                                   #telephone="ngModel"
                                   required>
                            <div class="error-msg"
                                 *ngIf="!telephone.valid && (telephone.touched || recommendFormCandidate.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                    </div>
                    <!-- Link Facebook-->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="facebookLink">{{'REFERAL.E_FACEBOOK' | translate}}</label>
                            <input type="text"
                                   id="facebookLink"
                                   class="form-control"
                                   ngModel
                                   name="facebookLink"
                                   placeholder="Link Facebook"
                                   #facebookLink="ngModel"
                            >
                        </div>
                    </div>
                    <!--Link LinkedIn -->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="linkedinLinkCand">{{'REFERAL.E_LINKEDIN' | translate}}</label>
                            <input type="text"
                                   id="linkedinLinkCand"
                                   class="form-control"
                                   ngModel
                                   name="linkedinLink"
                                   placeholder="{{'REFERAL.C_LK_PLACEHOLDER' | translate}}"
                                   #linkedinLink="ngModel"
                            >
                        </div>
                    </div>
                    <!-- Textarea-->
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label for="message">{{'REFERAL.E_DESCRIPTION' | translate}}</label>
                            <textarea class="form-control"
                                      id="message"
                                      type="text"
                                      rows="6"
                                      ngModel
                                      name="message"
                                      placeholder="{{'REFERAL.E_DESCRIPTION_PLACEHOLDER' | translate}}"
                                      #message="ngModel"
                                      required
                            ></textarea>
                            <div class="error-msg"
                                 *ngIf="!message.valid && (message.touched || recommendFormCandidate.submitted)">{{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>

                        </div>
                    </div>
                    <div class="col-lg-12 gdpr-fields">
                        <div class="form-group">
                            <input type="checkbox" id="personalGdprCand" name="personalGdprCand" [(ngModel)]="personalGdprCheckedCand">
                            <label for="personalGdpr">{{'REFERAL.TERMS_READ' | translate}} <a routerLink="/politica-confidentialitate">{{'REFERAL.POLICY' | translate}}</a> {{'REFERAL.AND' | translate}} <a routerLink="/termeni-si-conditii">{{'REFERAL.TERMS' | translate}}</a>.</label>
                            <div class="error-msg"
                                 *ngIf="!personalGdprCheckedCand && recommendFormCandidate.submitted">
                                {{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="checkbox" id="recomGdprCand" name="recomGdprCand" [(ngModel)]="recomGdprCheckedCand">
                            <label for="recomGdpr">{{'REFERAL.PERMISSION' | translate}}</label>
                            <div class="error-msg"
                                 *ngIf="!recomGdprCheckedCand && recommendFormCandidate.submitted">
                                {{'VALIDATION.REQUIRED' | translate}}
                                
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>
                    </div>

                    <!--Trimite button-->
                    <div class="col-lg-12">
                        <button type="submit"
                                class="green-button float-right"
                                ng-click="onSubmitCandidate(recommendFormCandidate)"
                        >{{'BUTTONS.SEND' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!--Footer-->
<app-footer></app-footer>
